module.exports = __webpack_public_path__ + "img/img_throw_5@3x_v2.9d880789.png";